import { useState } from "react";
import { EVENT_TYPES } from "./serviceMeta";

const ymd = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;

export const buildMonthGrid = (month) => {
  const [y, m] = month.split("-").map(Number);
  const first = new Date(y, m - 1, 1);
  const start = new Date(first);
  start.setDate(1 - ((first.getDay() + 6) % 7));
  const days = [];
  for (let i = 0; i < 42; i++) {
    const d = new Date(start);
    d.setDate(start.getDate() + i);
    days.push({ key: ymd(d), day: d.getDate(), inMonth: d.getMonth() === m - 1 });
  }
  return days[35].inMonth ? days : days.slice(0, 35);
};

export const eventsByDay = (events, first, last) => {
  const map = {};
  const add = (k, e) => (map[k] = map[k] || []).push(e);
  for (const e of events) {
    if (e.type === "hire") {
      const d = new Date(`${e.start < first ? first : e.start}T00:00:00`);
      const end = e.end > last ? last : e.end;
      while (ymd(d) <= end) {
        add(ymd(d), e);
        d.setDate(d.getDate() + 1);
      }
    } else add(e.date, e);
  }
  return map;
};

export const EventChip = ({ e, testid, canDrag }) => (
  <div data-testid={testid} title={`${e.title} — ${e.detail || ""}`} draggable={canDrag && e.type === "service"}
    onDragStart={(ev) => { ev.stopPropagation(); ev.dataTransfer.setData("text/plain", JSON.stringify({ id: e.id, date: e.date })); }}
    className={`text-[11px] leading-tight px-1.5 py-0.5 border-l-2 truncate ${EVENT_TYPES[e.type].chip} ${canDrag && e.type === "service" ? "cursor-grab" : ""} ${e.status === "cancelled" ? "line-through opacity-60" : ""}`}>
    {e.time && <span className="font-mono mr-1">{e.time}</span>}{e.title}
  </div>
);

export const DayCell = ({ day, items, selected, isToday, onSelect, canDrag, onMove }) => {
  const [over, setOver] = useState(false);
  return (
    <button type="button" onClick={() => onSelect(day.key)} data-testid={`schedule-day-${day.key}`}
      onDragOver={(ev) => { if (canDrag) { ev.preventDefault(); setOver(true); } }}
      onDragLeave={() => setOver(false)}
      onDrop={(ev) => {
        ev.preventDefault();
        setOver(false);
        try {
          const { id, date } = JSON.parse(ev.dataTransfer.getData("text/plain"));
          if (date !== day.key) onMove(id, day.key);
        } catch { /* ignore foreign drops */ }
      }}
      className={`text-left min-h-[112px] p-1.5 border-r border-b border-zinc-200 flex flex-col gap-1 transition-colors ${day.inMonth ? "bg-white" : "bg-zinc-50 text-zinc-400"} ${over ? "bg-sky-100" : ""} ${selected ? "ring-2 ring-inset ring-brand" : "hover:bg-sky-50/40"}`}>
      <span className={`text-xs font-bold w-6 h-6 flex items-center justify-center ${isToday ? "bg-brand text-white rounded-full" : ""}`}>{day.day}</span>
      {items.slice(0, 3).map((e, i) => <EventChip key={`${e.type}-${e.id}-${i}`} e={e} canDrag={canDrag} testid={`chip-${e.type}-${e.id}-${day.key}`} />)}
      {items.length > 3 && <span className="text-[10px] font-bold text-zinc-500">+{items.length - 3} more</span>}
    </button>
  );
};
